// extracted by mini-css-extract-plugin
export default {"widgetWrapper":"widgets_widgetWrapper__UJpRb","widgetSkeleton":"widgets_widgetSkeleton__WY39T"};